import React from 'react'
import { connect } from 'react-redux'
import { Button, MenuItem } from '@blueprintjs/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass'
import { faTrafficLight } from '@fortawesome/pro-solid-svg-icons/faTrafficLight'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import ButtonSelect from 'src/components/ButtonSelect'
import InputSelect from 'src/components/InputSelect'
import withUserData from 'src/HOCs/withUserData'
import * as runbookModules from 'src/store/modules/runbooks'
import {
    getCustomerResults,
    searchCustomer,
} from 'src/store/modules/cmdb/customers'

import styles from './runbooksFilters.module.scss'

export const lifecycleIcons = {
    circleIcon: <div className={styles.circle} />,
    triangleIcon: <div className={styles.triangle} />,
    squareIcon: <div className={styles.square} />,
    octagonIcon: <div className={styles.octagon} />,
}

class RunbooksFilters extends React.Component {
    state = {
        customerQuery: '',
    }

    handleSelectUsers = (user) => {
        const { toggleAccessType } = this.props

        if (user.selected) {
            return
        }

        toggleAccessType(user.value)
    }

    handleSelectEnvironment = (status) => {
        const { environmentTypes, toggleEnvironment } = this.props

        if (
            status.selected &&
            environmentTypes.filter((e) => e.selected).length === 1
        ) {
            return
        }

        toggleEnvironment(status.value)
    }

    render() {
        const {
            accessTypes,
            environmentTypes,
            customerFilter,
            searchCustomer,
            customers,
            setCustomerFilter,
            userData,
        } = this.props

        const selectedUser = accessTypes.filter((user) => user.selected)[0]
            .label
        const selectedEnvironment = environmentTypes.filter(
            (status) => status.selected
        )[0].label

        const isLoggedAsCegeka =
            parseInt(userData.data.organization_id) === 656 ||
            parseInt(userData.impersonatedOrganization?.id) === 656

        return (
            <div className={styles.headerWrapper}>
                <div className={styles.legend}>
                    {lifecycleIcons.circleIcon}
                    <span>In Development</span>

                    {lifecycleIcons.triangleIcon}
                    <span>Ready for Test</span>

                    {lifecycleIcons.squareIcon}
                    <span>Ready for Use</span>

                    {lifecycleIcons.octagonIcon}
                    <span>Archived</span>
                </div>
                <div className={styles.filtersWrapper}>
                    <div>
                        <ButtonSelect
                            label="Lifecycle"
                            icon={faTrafficLight}
                            items={environmentTypes}
                            itemRenderer={(item) => (
                                <MenuItem
                                    intent="none"
                                    active={item.selected}
                                    key={item.value}
                                    text={item.label}
                                    onClick={() =>
                                        this.handleSelectEnvironment(item)
                                    }
                                />
                            )}
                            selectedLabel={selectedEnvironment}
                            className={styles.statusSelect}
                        />
                        <ButtonSelect
                            label="Users"
                            icon={faUser}
                            items={accessTypes}
                            itemRenderer={(item) => (
                                <MenuItem
                                    intent="none"
                                    active={item.selected}
                                    key={item.value}
                                    text={item.label}
                                    onClick={() => this.handleSelectUsers(item)}
                                />
                            )}
                            selectedLabel={selectedUser}
                        />
                    </div>

                    {/* Show the select only if user belongs to Cegeka */}
                    {isLoggedAsCegeka ? (
                        <div>
                            <InputSelect
                                popoverProps={{ minimal: true }}
                                inputProps={{
                                    className: styles.searchInput,
                                    placeholder: 'Search organizations',
                                    leftElement: (
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    ),
                                }}
                                onQueryChange={(name) => searchCustomer(name)}
                                inputValueRenderer={() => null}
                                resetOnSelect={true}
                                items={customers}
                                onItemSelect={(customer) =>
                                    setCustomerFilter([
                                        ...customerFilter,
                                        customer,
                                    ])
                                }
                                itemRenderer={(
                                    item,
                                    { handleClick, modifiers }
                                ) => (
                                    <MenuItem
                                        active={modifiers.active}
                                        key={item.id}
                                        label={item.id}
                                        onClick={handleClick}
                                        text={item.name}
                                    />
                                )}
                            />
                            {customerFilter.map((customer) => (
                                <Button
                                    large
                                    rightIcon="cross"
                                    key={customer.id}
                                    text={customer.name}
                                    className={styles.customerFilterButton}
                                    onClick={() =>
                                        setCustomerFilter(
                                            customerFilter.filter(
                                                (c) => c.id !== customer.id
                                            )
                                        )
                                    }
                                />
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => {
        return {
            accessTypes: state.runbooks.access,
            environmentTypes: state.runbooks.stage,
            customers: getCustomerResults(state),
            customerFilter: state.runbooks.customerFilter,
        }
    },
    {
        toggleAccessType: runbookModules.getRunbooksDecorator(
            runbookModules.toggleAccessType
        ),
        toggleEnvironment: runbookModules.getRunbooksDecorator(
            runbookModules.toggleEnvironmentFilter
        ),
        setCustomerFilter: runbookModules.getRunbooksDecorator(
            runbookModules.setCustomerFilter
        ),
        searchCustomer,
    }
)(withUserData(RunbooksFilters))
